<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="table-responsive">
    <b-table
      class="table table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl"
      fixed show-empty responsive tbody-tr-class="one-line-td-table" :busy="loading" :fields="fields"
      :items="canRead(access) ? data : []">
      <!-- table busy template -->
      <template v-slot:table-busy="">
        <div class="text-center text-danger my-2">
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </div>
      </template>
      <!-- ./table busy template -->

      <!-- device status template -->
      <template v-slot:head(devcStatus)="data">
        <div class="text-center">
          {{ data.label }}
        </div>
      </template>
      <!-- ./device status template -->

      <!-- action template -->
      <template v-slot:cell(config)="data">
        <div class="text-center">
          <button v-if="data.item.devcType === 'rpm'" class="btn btn-outline-primary btn-sm"
            @click="openRpmConfig(data.item)">
            Config RPM
          </button>
          <button v-if="data.item.devcType === 'ae'" class="btn btn-outline-primary btn-sm"
            @click="openAeConfig(data.item)">
            Config AE
          </button>
        </div>
      </template>
      <template v-slot:cell(action)="data">
        <div class="text-center">
          <DeviceEdit :access="'master_device'" :device="data.item"
            :viewTo="{ name: 'DeviceDetail', params: { id: data.item.devcId }, query: $route.query }"
            @onDeleteClicked="onActionDelete"
            @onEditClicked="onActionEdit" @onDuplicateClicked="onActionDuplicate" />
        </div>
      </template>
      <!-- ./action template -->

      <!-- created at template -->
      <template v-slot:cell(devcCreatedTime)="data">
        <div class="text-center">
          {{ formatDate(data.value) }}
        </div>
      </template>
      <!-- ./created at template -->

      <!-- device status template -->
      <template v-slot:cell(devcStatus)="data">
        <div class="text-center">
          {{ normalizeStatus(data.value) }}
        </div>
      </template>
      <!-- ./device status template -->
    </b-table>
    <b-pagination v-model="pagination.current" :per-page="pagination.pageSize" :total-rows="pagination.totalSize"
      @change="onPaginationChanged"></b-pagination>
  </div>
</template>

<script>
import { formatDateTime } from '@/util/date';
import { DISPLAY_DATETIME } from '@/util/apiDatetime';
import DeviceEdit from './Edit';

export default {
  name: 'DeviceList',
  components: { DeviceEdit },
  props: ['access', 'data', 'group', 'loading', 'pagination'],
  computed: {
    fields() {
      const fields = [
        {
          key: 'devcName',
          label: 'Device Name',
        },
        {
          key: 'devcType',
          label: 'Device Type',
        },
        {
          key: 'devcLabel',
          label: 'Label',
        },
      ];

      if (this.canRead('master_device_unique_id')) {
        fields.push({
          key: 'devcUniqueId',
          label: 'Unique ID',
        });
      }

      fields.push({
        key: 'devcMass.massName',
        label: 'Link to Asset',
      });

      if (this.canRead('master_config_rpm') || this.canRead('master_config_ae')) {
        fields.push({
          key: 'config',
          label: 'Config',
        });
      }

      fields.push({
        key: 'action',
        label: '',
      });

      return fields;
    },
  },
  methods: {
    normalizeStatus(v) {
      if (v === '1') {
        return 'Approved';
      }

      return 'Not Approved';
    },
    formatDate(v) {
      return formatDateTime(v, DISPLAY_DATETIME);
    },
    onPaginationChanged(page) {
      this.$emit('onPageChanged', page);
    },
    onActionDelete(data) {
      this.$emit('onActionDelete', data);
    },
    onActionEdit(data) {
      this.$emit('onActionEdit', data);
    },
    onActionDuplicate(data) {
      this.$emit('onActionDuplicate', data);
    },
    openRpmConfig(device) {
      this.$router.push({ name: 'MasterConfigRpm', query: { devcId: device.devcId } });
    },
    openAeConfig(device) {
      this.$router.push({ name: 'MasterConfigAe', query: { devcId: device.devcId } });
    },
  },
};
</script>

<style scoped></style>
